import { defaultMessageReceived } from '../../actions/defaultMessageReceived';
import { getData } from '../../constants/asyncStatuses';
//@ts-expect-error untyped-file
import { getCurrentThreadHistoryEntry } from '../../thread-history/selectors/getCurrentThreadHistoryEntry';
//@ts-expect-error untyped-file
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getCompletedMessageId, getPartialOrdinal, getCompletedMessageTimestamp } from 'conversations-message-history/partial-message/operators/partialMessageGetters';
import { getTimestamp
//@ts-expect-error untyped-file
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { MESSAGE_RESULTS } from 'conversations-message-history/thread-history/constants/keyPaths';
export const partialMessageReceived = ({
  message,
  channel,
  threadId,
  publishContext
}) => (dispatch, getState) => {
  const currentState = getState();
  const entry = getCurrentThreadHistoryEntry(currentState);
  const historyData = getData(entry);
  const existingMessage = historyData === null || historyData === void 0 ? void 0 : historyData.getIn([...MESSAGE_RESULTS, message.get('completedMessageId')]);
  if (existingMessage) {
    var _getPartialOrdinal, _getPartialOrdinal2, _getTimestamp, _getTimestamp2;
    if (isCommonMessageFormat(existingMessage)) {
      // Don't overwrite common messages with partial messages
      return;
    }
    if (((_getPartialOrdinal = getPartialOrdinal(existingMessage)) !== null && _getPartialOrdinal !== void 0 ? _getPartialOrdinal : 0) > ((_getPartialOrdinal2 = getPartialOrdinal(message)) !== null && _getPartialOrdinal2 !== void 0 ? _getPartialOrdinal2 : 0) || ((_getTimestamp = getTimestamp(existingMessage)) !== null && _getTimestamp !== void 0 ? _getTimestamp : 0) > ((_getTimestamp2 = getTimestamp(message)) !== null && _getTimestamp2 !== void 0 ? _getTimestamp2 : 0)) {
      return;
    }
  }
  const stubMessage = message.set('id', getCompletedMessageId(message)).set('timestamp', getCompletedMessageTimestamp(message));
  dispatch(defaultMessageReceived(stubMessage, channel, threadId, publishContext));
};